import { VNPPI_TENDERS_KEY } from '../VNPPI/Enums'
import { isOfflineApproval } from './offlineReplayStatuses'
import { createOrderParams } from './orderUtils'
import { PAYMENT_TYPES, PAYMENT_TYPES_INTERNAL } from './paymentTypes'

// Not all states listed here are (currently) used. There are also more states in Stadium not listed here.
// https://github.com/venuenext/stadium/blob/master/app/models/order/states.rb
export const ORDER_STATES = {
  APPROVED_OFFLINE: 'approved_offline',
  AUTHORIZATION_FAILED: 'authorization_failed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  COMPLETION_PENDING: 'completion_pending',
  INCOMPLETE: 'incomplete',
  PARTIALLY_REFUNDED: 'partially_refunded',
  REFUNDED: 'refunded',
  SETTLEMENT_FAILED: 'settlement_failed',
  TABBED: 'tabbed',
  TABBED_OFFLINE: 'tabbed_offline',
}

export const STADIUM_ORDER_STATES = {
  PROCESSING: 'processing',
  SUBMITTED: 'submitted',
  SUBMISSION_FAILED: 'submission_failed',
  AUTHORIZATION_FAILED: 'authorization_failed',
  SETTLEMENT_FAILED: 'settlement_failed',
  COMPLETED: 'completed',
  COMPLETION_PENDING: 'completion_pending',
  APPROVED_OFFLINE: 'approved_offline',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  PARTIALLY_REFUNDED: 'partially_refunded',
  TABBED: 'tabbed',
  TABBED_OFFLINE: 'tabbed_offline',
}

export const submittedOrFailedStates = [STADIUM_ORDER_STATES.SUBMITTED, STADIUM_ORDER_STATES.SUBMISSION_FAILED]

export const INTERNAL_ORDER_STATES = {
  PREAUTH: 'preauth',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
}

export const isFinalState = (state) => {
  return [STADIUM_ORDER_STATES.AUTHORIZATION_FAILED, STADIUM_ORDER_STATES.COMPLETED].includes(state)
}

export const isQRPay = (order) => {
  if (order?.displayName === 'QR Pay') {
    return true
  }
  return order?.payments?.some((payment) => payment.paymentType === PAYMENT_TYPES.QR_PAY) || false
}

export const isRichCheckout = (order) => {
  if (order?.isRichCheckout) return true
  if (order?.displayName === 'App') return true

  return order?.payments?.some((payment) => payment.paymentType === PAYMENT_TYPES.RICH_CHECKOUT) || false
}

export const isOfflineCardSwitchedToCash = (order) => {
  if (order.payments?.[0]?.paymentType === PAYMENT_TYPES_INTERNAL.CASH && (isOfflineApproval(order) || order.isApprovedOffline))
    return true

  return false
}

// TODO: replace uses with getOrderIsTabbed selector
export const isTabbed = (order) => {
  return (
    order?.state === STADIUM_ORDER_STATES.TABBED ||
    createOrderParams(order)?.state === STADIUM_ORDER_STATES.TABBED ||
    order?.state === STADIUM_ORDER_STATES.TABBED_OFFLINE ||
    createOrderParams(order)?.state === STADIUM_ORDER_STATES.TABBED_OFFLINE
  )
}

// instead of matching for 'shift4_credit' or 'freedompay_credit', match for '_credit'
export const isCreditType = (paymentType) => {
  if (!paymentType) return false

  return paymentType.endsWith('_credit') || paymentType.endsWith('_token')
}

export const hasCreditType = (payments) => {
  if (!payments) return false

  return payments.some((p) => isCreditType(p.paymentType))
}

// check if payment type is one of the scanned tenders (vnppi)
export const isScannedTender = (paymentType) => {
  if (!paymentType) return false

  return Object.values(VNPPI_TENDERS_KEY).includes(paymentType)
}

// check if order has scanned tender but no credit card payment
export const isScannedTenderNonCC = (payments) =>
  !payments.some((p) => isCreditType(p.paymentType)) && payments.some((p) => isScannedTender(p.paymentType))

export const isAuthFailedTab = (order) => {
  if (order?.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) {
    return true
  }
  if (order?.state === STADIUM_ORDER_STATES.PARTIALLY_REFUNDED) {
    return true
  }
  return false
}

export const wasTabbed = (order) => {
  return (
    order?.state === STADIUM_ORDER_STATES.COMPLETION_PENDING ||
    createOrderParams(order)?.state === STADIUM_ORDER_STATES.COMPLETION_PENDING
  )
}

export const ORDERS_STATUS_OPTIONS = {
  OPEN_ORDERS: 'open orders',
  CLOSED_ORDERS: 'closed orders',
  ALL_ORDERS: 'all orders',
}

const CLOSED_ORDER_STATES = [
  ORDER_STATES['CANCELLED'],
  ORDER_STATES['COMPLETED'],
  ORDER_STATES['COMPLETION_PENDING'],
  ORDER_STATES['REFUNDED'],
  ORDER_STATES['SETTLEMENT_FAILED'],
]

const REMOVABLE_STATES = [ORDER_STATES['CANCELLED']]

class OrderStates {
  static isClosed = (orderState) => CLOSED_ORDER_STATES.includes(orderState)
  static isOpen = (orderState) => !CLOSED_ORDER_STATES.includes(orderState)
  static isRemovable = (orderState) => REMOVABLE_STATES.includes(orderState)
}

export default OrderStates
